<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer005">
<p class="endorsements"><span class="pagebreak" id="pagei" title="i"></span><span class="pagebreak" id="pageii" title="ii"></span><span class="pagebreak" id="pageiii" title="iii"></span><span class="pagebreak" id="pageiv" title="iv"></span><span class="pagebreak" id="pagev" title="v"></span></p>
<p class="tp3">Reformation Commentary on Scripture</p>
<p class="tp3">Old Testament V</p>
<p class="tp2">1–2 Samuel, 1–2 Kings, 1–2 Chronicles</p>
<p class="body"></p>
<p class="tp4"><br/></p>
<p class="tp4">Edited by<br/>
    Derek Cooper and Martin J. Lohrmann</p>
<p class="tp4">General Editor<br/>
    Timothy George</p>
<p class="tp4">Associate General Editor<br/>
    Scott M. Manetsch</p>
<p class="first"><br/></p>
<p class="firstcenter"><a href="http://www.IVPress.com/academic" target="_blank"><img alt="IVP Academic Imprint" src="Images/IVPAcademic.png"/></a></p>
<p class="first"><span class="pagebreak" id="pagevi" title="vi"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?1418ec50